import { groupBy, ICrop, sum } from "../../omnia"
import { INtrNutrients, INutritionPlan } from "../../types"
import { getNutrientKeys } from "../../utils"
import { IPlanCropping } from "./types"

export class PlanVm {

    public cropGroups: {
        crop: ICrop,
        area: number,
        cropping: IPlanCropping[]
    }[];

    public openingReq: INtrNutrients;
    public closingReq: INtrNutrients;
    public contrib: INtrNutrients;

    public precision: boolean;
    public manure: boolean;

    public nutrients: string[];

    public readonly planInfo = getPlanInfo(this)

    constructor(
        public readonly plan: INutritionPlan,
        public readonly cropping: IPlanCropping[],
        public readonly visible = !plan.Restricted
    ) {

        this.precision = plan.Precision;
        this.manure = plan.Applications && plan.Applications.some(a => !!a.ManureId);
        this.setupCropGroups();
        this.setupNutrients();

    }

    setupNutrients() {

        this.nutrients = getNutrientKeys().filter(n => {
            return this.cropping.some(c => c.applications.some(a => a.contributesNutrient(n)));
        });

    }

    setupCropGroups() {

        this.cropGroups = groupBy(this.cropping, c => c.cropping.crop, c => c.CropId).map(g => {
            return {
                crop: g.key,
                area: sum(g.values, c => c.cropping.area),
                cropping: g.values.sort((c1, c2) => c1.cropping.fieldName.localeCompare(c2.cropping.fieldName))
            }
        }).sort((g1, g2) => g2.area - g1.area);

    }

    get planId() {
        return this.plan.NutritionPlanId;
    }

    get name() {
        return this.plan.Name;
    }

    get applications() {
        return this.plan.Applications
    }

    get shouldRecalc() {
        return !!this.plan.ShouldRecalculate
    }

    findApplication(appId: number, croppingId: number) {

        return this.cropping.map(c => c.applications.find(a => (a.app.appId == appId) && (a.app.croppingId == croppingId))).find(a => !!a);

    }

}


function getPlanInfo(plan: PlanVm) {

    const getUniqueValues = (s: (c: IPlanCropping) => string) => plan.cropping.map(s).filter(n => n).unique(n => n)

    return {
        name: plan.name,
        fields: getUniqueValues(c => c.cropping.fieldName),
        crops: getUniqueValues(c => c.cropping.getCropName())
    }

}
